import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environments';

@Injectable({
  providedIn: 'root',
})
export class IndicadorAlertaDesproporcionalServicoService {
  constructor(private http: HttpClient) { }
  private apiUrl = environment.API_URL;
  private map = "ss.indicadoresalertas";

  getindicadores(codigo: number, codigoCentralPosto: string, ccFila: string, ccOrgao: string, login: string): Observable<any> {
      const url = this.apiUrl + this.map + '/getVagasServicoDia?id=' + codigo + '&ccPosto=' + codigoCentralPosto + '&ccFila=' + ccFila + '&ccOrgao=' + ccOrgao+'&login='+login;;
      console.log(url);
      return this.http.get(url);

  }
}
